import { TableRowProps } from '@material-ui/core';

import { ResourcePathArgs, useResourcePath } from '../../hooks/useResourcePath';
import { LinkableTableRowMui as LinkableTableRow } from '../LinkableTableRow/LinkableTableRowMui';

export type ResourceTableRowMuiProps = TableRowProps & ResourcePathArgs;

export const ResourceTableRowMui = ({
  routeRef,
  name,
  children,
  params,
  transform,
  ...tableRowProps
}: ResourceTableRowMuiProps) => {
  const path = useResourcePath({
    routeRef,
    name,
    params,
    transform,
  });

  return (
    <LinkableTableRow data-track-source-anchor="49e1301085;resource-table-row-mui-linkable-table-row" {...tableRowProps} to={path || ''}>
      {children}
    </LinkableTableRow>
  );
};
